import React, { useContext, useEffect } from 'react';
import { TKUIWithStyle, overrideClass, useStyles } from 'tripkit-react/dist/jss/StyleHelper';
import multiSignInFormJss from './MultiSignInForm.css';
import { CardPresentation, TKUIButton, TKUIButtonType, TKUICard } from 'tripkit-react';
import TKUISignInForm from 'tripkit-react/dist/account/TKUISignInForm';
import { LoginResult, SignInStatus, TKAccountContext } from 'tripkit-react/dist/account/TKAccountContext';
import { ReactComponent as LogoFull } from "../../images/logo-myway-full.svg";
import { SKEDGO_PRIVACY_POLICY_URL, SKEDGO_TERMS_OF_USE_URL } from 'tripkit-react/dist/util/Util';
import { useResponsiveUtil } from 'tripkit-react/dist/util/TKUIResponsiveUtil';
import { getEnvironmentConfig } from '../../environments';
import ConfirmSignInForm from './ConfirmSignInForm';
import { useI18n } from 'tripkit-react/dist/i18n/TKI18nProvider';

type IStyle = ReturnType<typeof multiSignInFormJss>

interface IProps extends TKUIWithStyle<IStyle, IProps> {
    onRequestClose?: () => void;
}

const envConfig = getEnvironmentConfig();

const MultiSignInForm: React.FunctionComponent<IProps> = (props: IProps) => {
    const { onRequestClose, classes } = useStyles(props, multiSignInFormJss);
    const { t } = useI18n();
    const { login, status } = useContext(TKAccountContext);
    const { portrait } = useResponsiveUtil();
    const [codeChallenge, setCodeChallenge] = React.useState<Exclude<LoginResult, void>>();
    async function handleLogin() {
        await login();
        console.log('login success');
        onRequestClose?.();
    };
    function onConfirmLogin(result: Exclude<LoginResult, void>) {
        setCodeChallenge(result);
    }
    useEffect(() => {
        if (status === SignInStatus.signedIn) {
            onRequestClose?.();
        }
    }, [status]);
    function handleRecoverClick() {
        window.open(envConfig.recover_ABT_account, '_blank');
    }

    const title = codeChallenge ? "Log in authentication" : t("Sign.in");
    const content = codeChallenge ? (
        <ConfirmSignInForm
            codeChallenge={codeChallenge}
            appName="MyWay+"
            onVerified={onRequestClose}
            onCancel={() => setCodeChallenge(undefined)}
        />
    ) : (
        <>
            <div className={classes.description}>
                Log in to access your MyWay+ QR code ticket, as well as for easy access of the Customer Portal
            </div>
            <TKUIButton onClick={handleLogin} text={"Continue with ACT Digital Account"} type={TKUIButtonType.SECONDARY} />
            <div className={classes.or}>
                <div />
                OR
                <div />
            </div>
            <TKUISignInForm onConfirmLogin={onConfirmLogin} />
            <TKUIButton
                text={"Recover account"}
                type={TKUIButtonType.PRIMARY_LINK}
                onClick={handleRecoverClick}
                styles={{
                    main: overrideClass({
                        fontWeight: 'normal'
                    })
                }}
            />
            <div className={classes.divider}></div>
            <div className={classes.termsAndPrivacy}>
                {/* react-polyglot does not support interpolation with JSX values */}
                {/* {t("By.continuing,.you.are.agreeing.to.our.X.and.X", { 0: <a href="https://www.actransit.org/terms-of-use/" target="_blank">Terms of Use</a>, 1: "b" })} */}
                By continuing, you agree to our <a href={SKEDGO_TERMS_OF_USE_URL} target="_blank">Terms of Service</a> and <a href={SKEDGO_PRIVACY_POLICY_URL} target="_blank">Privacy Policy</a>
            </div>
        </>
    );

    return (
        <TKUICard
            presentation={portrait ? CardPresentation.SLIDE_UP : CardPresentation.MODAL}
            slideUpOptions={{ draggable: false }}
            title={title}
            onRequestClose={onRequestClose}
            focusTrap={true}
        >
            <div className={classes.main}>
                <LogoFull className={classes.logo} />
                {content}
            </div>
        </TKUICard>
    )
};

export default MultiSignInForm;